var map = {
	"./decidim/avatar-multiuser.png": 67766,
	"./decidim/brands/google.svg": 6361,
	"./decidim/cc-badge.png": 46248,
	"./decidim/decidim-logo.svg": 65460,
	"./decidim/default-avatar.svg": 31308,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 43800,
	"./decidim/icons.svg": 62535,
	"./decidim/pattern.png": 61256,
	"./decidim/placeholder-card-g.svg": 24781,
	"./decidim/placeholder-card-l.svg": 97734,
	"./decidim/placeholder.jpg": 64133,
	"./decidim/remixicon.symbol.svg": 67017,
	"./decidim/vendor/leaflet/layers-2x.png": 66248,
	"./decidim/vendor/leaflet/layers.png": 24087,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 15330,
	"./decidim/vendor/leaflet/marker-icon.png": 52233,
	"./decidim/vendor/leaflet/marker-shadow.png": 59302,
	"./decidim/vendor/social-share-button/douban.svg": 3848,
	"./decidim/vendor/social-share-button/email.svg": 56197,
	"./decidim/vendor/social-share-button/facebook.svg": 49755,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 73493,
	"./decidim/vendor/social-share-button/hacker_news.svg": 30101,
	"./decidim/vendor/social-share-button/linkedin.svg": 54749,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 59470,
	"./decidim/vendor/social-share-button/pinterest.svg": 42971,
	"./decidim/vendor/social-share-button/reddit.svg": 82799,
	"./decidim/vendor/social-share-button/telegram.svg": 25378,
	"./decidim/vendor/social-share-button/tumblr.svg": 52993,
	"./decidim/vendor/social-share-button/twitter.svg": 44500,
	"./decidim/vendor/social-share-button/vkontakte.svg": 5002,
	"./decidim/vendor/social-share-button/wechat.svg": 4181,
	"./decidim/vendor/social-share-button/whatsapp.svg": 81349,
	"./decidim/vendor/social-share-button/x.svg": 69125,
	"./decidim/vendor/social-share-button/xing.svg": 84123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90639;